<div [formGroup]="birthdateForm">
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.BIRTH_DATE' | translate }}*</h1>
    <div class="input-box">
      <input 
        type="date" 
        formControlName="birth_date" 
        class="input"
        [placeholder]="'FORM.PLACEHOLDER.BIRTH_DATE' | translate"
        [ngStyle]="{'border': (submitted && birthdateControl?.hasError('required')) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
      />
    </div>
    <span
      *ngIf="submitted && birthdateControl?.hasError('required')"
      class="error-message"
    >
      {{ 'FORM.ERROR.REQUIRED' | translate }}
    </span>
    <span
      *ngIf="submitted && birthdateControl?.hasError('minAge')"
      class="error-message"
    >
      {{ 'FORM.ERROR.MIN_AGE' | translate:{age: minAge} }}
    </span>
    <span
      *ngIf="submitted && birthdateControl?.hasError('maxAge')"
      class="error-message"
    >
      {{ 'FORM.ERROR.MAX_AGE' | translate:{age: maxAge} }}
    </span>
    <span
      *ngIf="submitted && birthdateControl?.hasError('invalidDate')"
      class="error-message"
    >
      {{ 'FORM.ERROR.INVALID_DATE' | translate }}
    </span>
  </div>
</div>
